// extracted by mini-css-extract-plugin
module.exports = {"container":"SearchResultContainer_container__Is3tI","title":"SearchResultContainer_title__2IY0d","childrenContainer":"SearchResultContainer_childrenContainer__mowv_"};